import React, { useState } from 'react';
import { Icon } from '@material-ui/core';
import {TextFormattedNumber} from 'components';


const OrderItemDetails = ({item, itemDetails}) => {
  const [showDetails, toggleShowDetails] = useState(false);

  return (
    <>
      {showDetails ?
        <>
          <div className="link mt-1 ml-1" onClick={() => toggleShowDetails(false)}>
            <Icon className="text-12">keyboard_arrow_down</Icon>
            {' Hide Details'}
          </div>
          {!!itemDetails &&
            <div className="ml-2 mt-2">
              <div><span className="font-bold">{'SKU: '}</span>{item.sku}</div>
              {!!itemDetails?.options?.options?.length &&
                itemDetails?.options?.options.map((option, idx) => (
                  <div key={`item-option${idx}`}>
                    <div className="font-bold">{`${option.label}:`}</div>
                    <div dangerouslySetInnerHTML={{__html: option.value}} className="ml-2" />
                  </div>
                ))
              }
              {!!itemDetails.gift_cards?.length &&
              <>
                <div>
                  <span className="font-bold">{'Gift Card Amount: '}</span>
                  <TextFormattedNumber
                    value={itemDetails.options.amount}
                    prefix="$"
                  />
                </div>
                <div>
                  <span className="font-bold">{'Sender: '}</span>
                  <span>{itemDetails.options.sender}</span>
                </div>
                <div>
                  <span className="font-bold">{'Recipient: '}</span>
                  <span>{itemDetails.options.recipient}</span>
                </div>
                <div>
                  <span className="font-bold">{'Delivery To: '}</span>
                  <span>{itemDetails.options.delivery_address}</span>
                </div>
                {!!itemDetails.options.phone &&
                  <div>
                    <span className="font-bold">{'Phone: '}</span>
                    <span>{itemDetails.options.phone}</span>
                  </div>
                }
                {!!itemDetails.options.birthday &&
                  <div>
                    <span className="font-bold">{'Birthday: '}</span>
                    <span>{itemDetails.options.birthday}</span>
                  </div>
                }
                <div>
                  <span className="font-bold">{'Gift Codes: '}</span>
                  <span>
                    {itemDetails.gift_cards.map((card) => (
                      `${card.code}${card.init_balance !== card.balance ? '(used)' : ''}`
                    )).join(', ')
                    }
                  </span>
                </div>
              </>
              }
              {!!itemDetails.options?.additional_options &&
                itemDetails.options.additional_options.map((option, idx) => (
                  <div key={`additional-option${idx}`}>
                    <div className="font-bold">{`${option.label}:`}</div>
                    <div className="ml-2">{option.value}</div>
                  </div>
                ))
              }
            </div>
          }
        </>
        :
        <div className="link mt-1 ml-1" onClick={() => toggleShowDetails(true)}>
          <Icon className="text-12">keyboard_arrow_right</Icon>
          {' Show Details'}
        </div>
      }
    </>
  );
};

export default OrderItemDetails;
